import ContactUs from '../../app/features/ContactUs';
const ContactUSPage = () => <ContactUs />

export default ContactUSPage